import { Suggestion } from './AutoCompleteList';

export type FlattenedSuggestion = {
  id: string;
  displayedText?: string;
  text: string;
};
export function flattenSuggestions(suggestions?: Suggestion[] | Suggestion): FlattenedSuggestion[] | null {
  if (!suggestions) {
    return null;
  }

  if (Array.isArray(suggestions) && suggestions.length == 0) {
    return null;
  }

  let flattenedSuggestions: FlattenedSuggestion[] = [];

  if (!Array.isArray(suggestions)) {
    flattenedSuggestions = suggestionsToSingleSuggestionArray(suggestions);
  } else if (Array.isArray(suggestions) && suggestions.length > 0) {
    flattenedSuggestions = suggestions.reduce((accumulator, suggestion) => {
      const explodedSuggestions = suggestionsToSingleSuggestionArray(suggestion);
      return [...accumulator, ...explodedSuggestions];
    }, [] as FlattenedSuggestion[]);
  }

  return flattenedSuggestions;
}

function suggestionsToSingleSuggestionArray(suggestions: Suggestion): FlattenedSuggestion[] {
  return suggestions.values.map((value) => ({
    id: value.id,
    displayedText: value.displayedText,
    text: value.text,
  }));
}
